<script setup>
import { useModalogStore } from "@/stores/modalog.js";
import BrandButton from "@/Components/Brand/BrandButton.vue";

const props = defineProps({
    // Most-recent wish list, used as the target when adding a gift.
    defaultList: {
        type: Object,
        default: null,
    },
});

const { showModalog } = useModalogStore();

function createList() {
    showModalog({
        type: "ModalogCreateListBrand",
        props: { listType: "wish" },
    });
}

function addGift() {
    // The add-gift modal shows a destination-list picker when no list is
    // preselected. With no lists at all, there's nothing to pick — create one.
    if (!props.defaultList) {
        createList();

        return;
    }

    showModalog({
        type: "ModalogAddGiftBrand",
        props: { listType: "wish", listUuid: null },
    });
}
</script>

<template>
    <!-- Always side by side (Craig's 1170 frame, 443-218, keeps them 2-up in
         the lg sidebar); tighter padding there so both labels fit 142px. -->
    <div class="flex items-center gap-4">
        <!-- Create List: navy fill, white label, red playlist-add icon -->
        <BrandButton
            icon-rest-class="text-brand-red"
            class="h-[52px] flex-1 px-4 text-[15px] lg:px-2 xl:px-4"
            @click="createList"
        >
            <template #icon>
                <svg
                    viewBox="0 0 22 18"
                    class="h-[18px] w-[22px]"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                >
                    <path d="M1 3.5h12M1 9h12M1 14.5h7" />
                    <path d="M18 8.5v8M14 12.5h8" />
                </svg>
            </template>
            Create List
        </BrandButton>

        <!-- Add Gift: navy fill, white label, red circle-plus icon -->
        <BrandButton
            icon-rest-class="text-brand-red"
            class="h-[52px] flex-1 px-4 text-[15px] lg:px-2 xl:px-4"
            @click="addGift"
        >
            <template #icon>
                <span
                    class="grid size-6 place-items-center rounded-full border-2 border-solid border-current"
                >
                    <!-- Even size keeps the glyph's centering offset integral
                         inside the 24px circle; an odd size rasterizes the
                         resting and hover-lift composites a half-pixel apart
                         (same fix as FollowButton). -->
                    <svg
                        viewBox="0 0 14 14"
                        class="h-3 w-3"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.6"
                        stroke-linecap="round"
                        aria-hidden="true"
                    >
                        <path d="M7 2.5v9M2.5 7h9" />
                    </svg>
                </span>
            </template>
            Add Gift
        </BrandButton>
    </div>
</template>
